/**
 * 主に環境変数の値など、システム全体で利用する定数です。
 */
export default Object.freeze({
  // アプリケーションドメイン
  APP_DOMAIN: process.env.VUE_APP_DOMAIN,

  // アプリケーションURL
  APP_URL: process.env.VUE_APP_URL,

  // API ベースURL
  API_BASE_URL: process.env.VUE_APP_API_BASE_URL,

  // API キー
  API_KEY: process.env.VUE_APP_API_KEY,

  // Cognito REGION
  COGNITO_REGION: process.env.VUE_APP_COGNITO_REGION,

  // Cognito IDPOOL_ID
  COGNITO_IDPOOL_ID: process.env.VUE_APP_COGNITO_IDPOOL_ID,

  // Cognito USERPOOL_ID
  COGNITO_USERPOOL_ID: process.env.VUE_APP_COGNITO_USERPOOL_ID,

  // Cognito CLIENT_ID
  COGNITO_CLIENT_ID: process.env.VUE_APP_COGNITO_CLIENT_ID,

  // こころコンディショナーPLUSログインURL
  COCORO_LOGIN_URL: process.env.VUE_APP_COCORO_LOGIN_URL,

  // 睡眠日誌アプリAndroid版URL
  SLEEP_ANDROID_URL: process.env.VUE_APP_SLEEP_ANDROID_URL,

  // 睡眠日誌アプリiPhone版URL
  SLEEP_IPHONE_URL: process.env.VUE_APP_SLEEP_IPHONE_URL,

  AKITA_RESEARCH_EXKEY_PREFIX: 'Ckk_xLu5PK-3f4Es',

  // API ユーザー登録・更新・取得処理URL
  API_NOLOGINUSER_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/nologinuser',

  // API サインアップ
  API_USERS_SIGNUP_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/user/signup',

  // API ユーザ情報登録
  API_USERS_REGIST_USER_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/user/registuser',

  // API メールアドレス変更
  API_USERS_UPDATE_EMAIL_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/user/updateemail',

  // API メールアドレス変更検証
  API_USERS_VERIFY_EMAIL_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/user/verifyemail',

  // API プロフィール参照
  API_USER_REFERENCE: '/' + process.env.VUE_APP_API_STAGE + '/api/user/userreference',

  // API プロフィール更新
  API_USER_MAINTENANCE: '/' + process.env.VUE_APP_API_STAGE + '/api/user/usermaintenance',

  // API ユーザ削除済みチェック
  API_USER_DELETED_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/user/userdeleted',

  // API ユーザ退会処理
  API_USER_DELETE_ACCOUNT: '/' + process.env.VUE_APP_API_STAGE + '/api/user/deleteaccount',

  // API ユーザプラン追加申請処理URL
  API_USER_PLAN_ADDITION_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/user/planapplication',

  // API ユーザプラン解除処理
  API_USER_UNREGIST_PLAN: '/' + process.env.VUE_APP_API_STAGE + '/api/user/unregistplan',

  // API サービス利用状況一覧取得処理
  API_USER_SERVICE_STATUS: '/' + process.env.VUE_APP_API_STAGE + '/api/user/servicestatus',

  // 会員に関する規約取得処理URL
  API_TERMS_USERS_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/terms/users',

  // 個人に関する規約取得処理URL
  API_TERMS_PERSONAL_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/terms/personal',

  // 会員に関する規約の合意情報登録処理URL
  API_TERMS_HISTORY_USERS_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/termsHistory/users',

  // 個人に関する規約の合意情報登録処理URL
  API_TERMS_HISTORY_PERSONAL_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/termsHistory/personal',

  // API タグ暗号化・複合化処理URL
  API_TAGS_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/user/tags',

  // API テナント有効・外部連携パラメータチェック処理URL
  API_USER_REGIST_ADD_INFO_CHECK_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/user/registaddinfo/check',

  // API 追加情報関連 テナント情報取得処理URL
  API_USER_REGIST_ADD_INFO_TENANT_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/user/registaddinfo/tenant',

  // API 追加情報登録処理URL
  API_USER_REGIST_ADD_INFO_URI: '/' + process.env.VUE_APP_API_STAGE + '/api/user/registaddinfo',

  // APIエラー時のリトライ回数
  API_LIMIT_RETRY_COUNT: 1,

  // APIタイムアウト値（ミリ秒）
  API_TIMEOUT: 10000,

  // ニックネーム 最大文字数
  NICKNAME_MAX_NUM: 100,

  // メールアドレス 最大文字数
  EMAIL_ADDRESS_MAX_NUM: 254,

  // パスワード 最小文字数
  PASSWORD_MIN_NUM: 8,

  // パスワード 最大文字数
  PASSWORD_MAX_NUM: 256,

  // 確認コード 最大文字数
  VERIFY_CODE_MAX_NUM: 10,

  // テナントコード 最大文字数
  TENANT_CODE_MAX_NUM: 255,

  // 特定情報 最大文字数
  SPEC_INFO_MAX_NUM: 100,

  // Google Analytics
  GOOGLE_ANALYTICS_TRACKING_ID: 'G-NKTSM0H8VX',
  GOOGLE_ANALYTICS_TARGET_DOMAINS: [process.env.VUE_APP_DOMAIN],

  // ユーザ情報 性別セレクトボックス
  USER_INFO_GENDER_OPTIONS: ['male', 'female', 'other', 'nothing'],

  // ユーザ情報 都道府県セレクトボックス
  USER_INFO_RESIDENCE_OPTIONS: [
    'hokkaido',
    'aomori',
    'iwate',
    'miyagi',
    'akita',
    'yamagata',
    'fukushima',
    'ibaraki',
    'tochigi',
    'gunma',
    'saitama',
    'chiba',
    'tokyo',
    'kanagawa',
    'niigata',
    'toyama',
    'ishikawa',
    'fukui',
    'yamanashi',
    'nagano',
    'gifu',
    'shizuoka',
    'aichi',
    'mie',
    'shiga',
    'kyoto',
    'osaka',
    'hyogo',
    'nara',
    'wakayama',
    'tottori',
    'shimane',
    'okayama',
    'hiroshima',
    'yamaguchi',
    'tokushima',
    'kagawa',
    'ehime',
    'kochi',
    'fukuoka',
    'saga',
    'nagasaki',
    'kumamoto',
    'oita',
    'miyazaki',
    'kagoshima',
    'okinawa',
    'other'
  ],

  // ユーザ情報 職業セレクトボックス
  USER_INFO_JOB_OPTIONS: [
    'kaisha_hikanri',
    'kaisha_kanri',
    'kaisha_keiei',
    'kaisha_hiseiki',
    'koumuin',
    'jieigyo',
    'iryou',
    'gakusei',
    'mushoku',
    'sonota'
  ],

  // ユーザ情報 職種セレクトボックス
  USER_INFO_JOBTYPE_OPTIONS: [
    'eigyo',
    'jimu',
    'kikaku',
    'service',
    'web',
    'creative',
    'senmon',
    'tech_soft',
    'tech_denki',
    'tech_sozai',
    'tech_medical',
    'tech_doboku',
    'tech_setsubi',
    'sonota'
  ],

  // ドメイン名ラベル最大文字数
  DOMAIN_LABEL_MAX_NUM: '63',

  // Cookie有効期限（秒×分×時間×日数）
  COOKIE_EXPIRE_TIMES: 60 * 60 * 24 * 90
});
